import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { ControlLabel } from 'react-bootstrap';
import ModalForm from 'components/ModalForm';
import messages from './messages';
import styles from './styles.css';

/* Used to force auto focus to input on mount */
const Input = (field) => {
  const { input, type, meta: { error } } = field;
  const innerRef = useRef();
  useEffect(() => innerRef.current && innerRef.current.focus(), []);
  return (
    <React.Fragment>
      <input {...input} type={type} className="form-control" ref={innerRef} data-test-handle="account-number-input" />
      <span className={styles.error} >
        {error}
      </span>
    </React.Fragment>
  );
};

const validate = (values) => {
  const errors = {};

  if (values.updatedAccount && values.updatedAccount.indexOf(' ') !== -1) {
    errors.updatedAccount = <FormattedMessage {...messages.error} />;
  }
  return errors;
};

const UpdateAccountForm = ({ handleSubmit, show, onHide }) => (
  <ModalForm
    onHide={onHide}
    show={show}
    handleSubmit={handleSubmit}
    title={<FormattedMessage {...messages.editAccount} />}
    submitLabel={<FormattedMessage {...messages.updateWire} />}
  >
    <ControlLabel className={styles.controlLabel} htmlFor="updatedAccount">
      <FormattedMessage {...messages.account} />
      <Field
        required
        name="updatedAccount"
        component={Input}
        type="text"
        className="form-control"
        data-test-handle="account-number-field"
      />
    </ControlLabel>
  </ModalForm>
);


Input.propTypes = {
  field: PropTypes.object.isRequired,
};

UpdateAccountForm.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'UpdateAccount',
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(UpdateAccountForm);



// WEBPACK FOOTER //
// ./src/components/UpdateAccountForm/index.js